import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const [authStatus, setAuthStatus] = useState("checking");  
  const location = useLocation();

  useEffect(() => {
    let isMounted = true;
    
    const checkSession = async () => {
      const isLoggedIn = localStorage.getItem("isLoggedIn");
    
      if (!isLoggedIn) {
        if (isMounted) {
          setAuthStatus("unauthenticated");
        }
        return;
      }
      try {
        const res = await fetch("/api/auth/check-session", {
          method: "GET",
          credentials: "include",
        });
        if (!isMounted) return;

        if (res.status === 200) {
          setAuthStatus("authenticated");
        } else {
          localStorage.removeItem("isLoggedIn");
        }
      } catch (err) {
        console.error("Session check failed:", err);
        localStorage.removeItem("isLoggedIn");
      }
    };

    checkSession();
    const intervalId = setInterval(checkSession, 5 * 60 * 1000);

    return () => {
      isMounted = false;
      clearInterval(intervalId);
    };
  }, [location.pathname]); 

   
  if (authStatus === "checking") {
    return null;  
  }

  if (authStatus === "unauthenticated") {
    return <Navigate to="/" replace />;
  }
  if (!localStorage.getItem("isLoggedIn")) {
    return <Navigate to="/Login" state={{ from: location, reason: "session-expired" }} replace />;
  }

  return children;
};

export default ProtectedRoute;